module.exports = __webpack_public_path__ + "assets/img/1431587607482_.pic_hd.afd071ed.jpg";